import { changeManufacturerAccountPassword } from "app/services/manufacturers/manufacturers";
import { useState } from "react";
import { TOAST_SEVERITY } from "static/constants";
import { showToast } from "utils/toast";

const useChangePasswordForm = ({
  handleClose,
  selectedManufacturerAccount,
  fetchManufacturerAccounts,
}) => {
  const initialValues = {
    currentPassword: "",
    newPassword: "",
    confirmNewPassword: "",
  };

  const [isProcessing, setIsProcessing] = useState(false);

  const handleFormSubmit = async (values) => {
    try {
      setIsProcessing(true);

      const { _id } = selectedManufacturerAccount;
      const { confirmNewPassword, ...payload } = values;
      const { type, message } = await changeManufacturerAccountPassword(
        _id,
        payload
      );

      if (type === "Success") {
        showToast({ message });
        await fetchManufacturerAccounts();
        handleClose("success");
      }
    } catch (error) {
      showToast({ message: error.message, type: TOAST_SEVERITY.ERROR });
    } finally {
      setIsProcessing(false);
    }
  };

  return {
    initialValues,
    isProcessing,
    handleFormSubmit,
  };
};

export default useChangePasswordForm;
